import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  Typography,
  Box,
  Button,
  IconButton,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Link,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const MandateDaySelectionModal = ({ open, onClose, onConfirm }) => {
  const [selectedDay, setSelectedDay] = useState("");

  const handleConfirm = () => {
    if (!selectedDay) return;
    onConfirm(selectedDay);
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      PaperProps={{
        sx: {
          borderRadius: 3,
          backgroundColor: "#f9fafb",
        },
      }}
    >
      <DialogContent sx={{ p: 0 }}>
        {/* Header */}
        <Box
          sx={{
            px: 3,
            py: 2,
            borderBottom: "1px solid #e5e7eb",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography
            sx={{
              fontSize: 20,
              fontWeight: 600,
              color: "#111827",
            }}
          >
            Select EMI Debit Day
          </Typography>

          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>

        {/* Body */}
        <Box sx={{ px: 3, py: 3 }}>
          {/* Dropdown */}
          {/* <FormControl fullWidth size="medium">
            <InputLabel sx={{ fontSize: "18px" }}>Select Day</InputLabel>

            <Select
              value={selectedDay}
              label="Select Day"
              onChange={(e) => setSelectedDay(e.target.value)}
              sx={{
                fontSize: "18px", // selected value text size
              }}
              MenuProps={{
                PaperProps: {
                  sx: {
                    "& .MuiMenuItem-root": {
                      fontSize: "18px", // dropdown item text size
                    },
                  },
                },
              }}
            >
              {[...Array(10)].map((_, index) => (
                <MenuItem key={index + 1} value={`Day ${index + 1}`}>
                  Day {index + 1}
                </MenuItem>
              ))}
            </Select>
          </FormControl> */}

          <FormControl fullWidth size="medium">
            <InputLabel sx={{ fontSize: "18px" }}>Select Day</InputLabel>

            <Select
              value={selectedDay}
              label="Select Day"
              onChange={(e) => setSelectedDay(e.target.value)}
              sx={{ fontSize: "18px" }}
              MenuProps={{
                PaperProps: {
                  sx: {
                    "& .MuiMenuItem-root": {
                      fontSize: "18px", // dropdown item text size
                    },
                  },
                },
              }}
            >
              {[...Array(10)].map((_, index) => (
                <MenuItem key={index + 1} value={`Day ${index + 1}`}>
                  Day {index + 1}
                </MenuItem>
              ))}
            </Select>

            {!selectedDay && (
              <Typography
                sx={{
                  color: "#6b7280",
                  fontSize: "14px",
                  mt: 0.7,
                }}
              >
                Please select your EMI debit day to proceed.
              </Typography>
            )}
          </FormControl>
          {/* Note */}
          <Typography
            sx={{
              mt: 2,
              fontSize: 16,
              color: "#6b7280",
              lineHeight: 1.6,
            }}
          >
            Note: The selected debit day will be used for automatic EMI debit
            through the registered bank mandate. Please ensure sufficient
            balance in your account before the debit day.
          </Typography>

          {/* Terms & Conditions */}
          {/* <Typography
            sx={{
              mt: 2,
              fontSize: 14,
              color: "#374151",
            }}
          >
            By proceeding you agree to the{" "}
            <Link
              href="/terms-and-conditions"
              target="_blank"
              underline="hover"
              sx={{ fontWeight: 500 }}
            >
              Terms & Conditions
            </Link>
          </Typography> */}

          {/* Buttons */}
          <Box
            sx={{
              mt: 3,
              display: "flex",
              justifyContent: "flex-end",
              gap: 1.5,
            }}
          >
            <Button
              variant="outlined"
              onClick={() => {
                setSelectedDay(""); // reset dropdown
                onClose(); // close modal
              }}
              sx={{
                borderRadius: 2,
                textTransform: "none",
                fontSize: "16px",
              }}
            >
              Cancel
            </Button>

            {/* <Button
              variant="contained"
              onClick={handleConfirm}
              disabled={!selectedDay}
              style={{
                ...confirmBtnStyle,
              }}
              sx={{
                borderRadius: 2,
                textTransform: "none",
                backgroundColor: "#154779",
                fontSize: "17px",
                "&:hover": {
                  backgroundColor: "#0f355c",
                },
              }}
            >
              Confirm
            </Button> */}
            <Button
              variant="contained"
              onClick={handleConfirm}
              disabled={!selectedDay}
              style={{
                ...confirmBtnStyle,
                backgroundColor: selectedDay ? "#154779" : "#94a3b8",
              }}
              sx={{
                borderRadius: 2,
                textTransform: "none",
                fontSize: "17px",
                
                "&:hover": {
                  backgroundColor: selectedDay ? "#0f355c" : "#94a3b8",
                },
              }}
            >
              Confirm
            </Button>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default MandateDaySelectionModal;

const confirmBtnStyle = {
  height: "48px",
  borderRadius: "12px",
  border: "none",
  color: "#ffffff",
  fontSize: "1.52rem",
  backgroundColor: "rgb(22, 52, 117)",
};